import axios from 'axios'

import { Toast } from 'antd-mobile';

axios.defaults.timeout = 100000;//超时时间

//默认toast
axios.interceptors.request.use( ( config ) => {
    Toast.loading( '加载中', 0, false, (config.isLoadingMask === false ? false : true));
    return config;
}, () => {
    Toast.hide();
    Toast.info( "网络异常" );
} )

// 拦截相应
axios.interceptors.response.use( ( response ) => {
	const { data = {}, headers } = response;
	if (headers['x-portal-api-code'] === '400') {
		// 所有异常
		if (data.status === '10006') {
			// 登录异常
			Toast.fail('用户未登录');
		} else if (data.status === '-1') {
			Toast.fail('网络错误，请稍后再试');
		} else {
			Toast.fail(data.exception || '系统内部错误，请稍后再试');
		}
		throw data;
	}
	Toast.hide();
	return response
}, ( error ) => {
    Toast.hide();
    if ( error.response ) {
        Toast.fail( ( error.response.data || {} ).exception || "未知异常" );
        return error.response.data;
    } else if ( error.request ) {
        Toast.fail( "未知异常" );
        return error.request;
    } else {
        Toast.fail( error.message || "请求异常" );
        return error;
    }
    return error;
} );

export default axios



// WEBPACK FOOTER //
// ./src/utils/http/index.js